<main class="main-content">
  <div class="admin">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-8">
          <div class="edit-profile">
            <div class="edit-profile__logos">
              <a href="index.html">
                <img class="dark" src="assets/img/logo_png.png" alt="" />
                <img class="light" src="assets/img/logo_png.png" alt="" />
              </a>
            </div>
            <div class="card border-0">
              <div class="card-header">
                <div
                  class="d-flex justify-content-between align-items-center w-100"
                >
                  <div class="edit-profile__title">
                    <h6>
                      {{ "auth.signIn" | translate }}
                    </h6>
                  </div>

                  <!-- <div class="lang-switcher">
                    <button
                      *ngFor="let l of lang.SUPPORTED_LANGS"
                      (click)="lang.setLang(l)"
                      [class.active]="lang.currentLang === l"
                      class="lang-btn"
                    >
                      {{ l.toUpperCase() }}
                    </button>
                  </div> -->
                  <button
                    class="lang-globe-btn"
                    (click)="openLangModal()"
                    [attr.aria-label]="'Change language'"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <line x1="2" y1="12" x2="22" y2="12" />
                      <path
                        d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                      />
                    </svg>
                    <span class="lang-globe-label">{{
                      lang.currentLang.toUpperCase()
                    }}</span>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="edit-profile__body">
                  <div class="form-group mb-25">
                    <label for="username">
                      <!-- Email -->
                      {{ "auth.emailLabel" | translate }}
                    </label>
                    <input
                      type="email"
                      [(ngModel)]="formData.email"
                      name="email"
                      class="form-control"
                      id="username"
                      [placeholder]="'auth.emailPlaceholder' | translate"
                      required
                      (input)="convertEmailToLowerCase()"
                      (keydown.enter)="isValidEmail() && sendCodeOnEmail()"
                    />
                  </div>
                  <div *ngIf="isSendedCode">
                    <div>
                      <div class="code-inputs">
                        <input
                          #codeOne
                          type="text"
                          [(ngModel)]="formData.one"
                          name="one"
                          maxlength="6"
                          inputmode="numeric"
                          required
                          (input)="onCodeInput($event, 'one')"
                          (keydown)="onCodeKeydown($event, 'one')"
                          (keydown.enter)="isFormValid() && login()"
                        />
                        <input
                          #codeTwo
                          type="text"
                          [(ngModel)]="formData.two"
                          name="two"
                          maxlength="1"
                          inputmode="numeric"
                          required
                          (input)="onCodeInput($event, 'two')"
                          (keydown)="onCodeKeydown($event, 'two')"
                          (keydown.enter)="isFormValid() && login()"
                        />
                        <input
                          #codeThree
                          type="text"
                          [(ngModel)]="formData.three"
                          name="three"
                          maxlength="1"
                          inputmode="numeric"
                          required
                          (input)="onCodeInput($event, 'three')"
                          (keydown)="onCodeKeydown($event, 'three')"
                          (keydown.enter)="isFormValid() && login()"
                        />
                        <input
                          #codeFour
                          type="text"
                          [(ngModel)]="formData.four"
                          name="four"
                          maxlength="1"
                          inputmode="numeric"
                          required
                          (input)="onCodeInput($event, 'four')"
                          (keydown)="onCodeKeydown($event, 'four')"
                          (keydown.enter)="isFormValid() && login()"
                        />
                        <input
                          #codeFive
                          type="text"
                          [(ngModel)]="formData.five"
                          name="five"
                          maxlength="1"
                          inputmode="numeric"
                          required
                          (input)="onCodeInput($event, 'five')"
                          (keydown)="onCodeKeydown($event, 'five')"
                          (keydown.enter)="isFormValid() && login()"
                        />
                        <input
                          #codeSix
                          type="text"
                          [(ngModel)]="formData.six"
                          name="six"
                          maxlength="1"
                          inputmode="numeric"
                          required
                          (input)="onCodeInput($event, 'six')"
                          (keydown)="onCodeKeydown($event, 'six')"
                          (keydown.enter)="isFormValid() && login()"
                        />
                      </div>
                      <br />
                    </div>
                  </div>
                  <div *ngIf="errorMessage" class="alert alert-danger">
                    {{ errorMessage }}
                  </div>
                  <div
                    *ngIf="notificationMessage && !errorMessage"
                    class="alert alert-success"
                  >
                    {{ notificationMessage }}
                  </div>
                  <div
                    *ngIf="!isSendedCode"
                    class="admin__button-group button-group d-flex pt-1 justify-content-md-start justify-content-center"
                  >
                    <button
                      class="btn btn-primary btn-default w-100 btn-squared text-capitalize lh-normal px-50 signIn-createBtn"
                      (click)="sendCodeOnEmail()"
                      [disabled]="!isValidEmail()"
                    >
                      <!-- Send code -->
                      {{ "auth.sendCode" | translate }}
                    </button>
                  </div>
                  <div class="send-code-container">
                    <span
                      *ngIf="isSendCodeDisabled && isSendedCode"
                      class="timer"
                    >
                      {{ countdown }}
                    </span>
                    <button
                      *ngIf="isSendedCode"
                      [disabled]="isSendCodeDisabled"
                      (click)="sendCodeOnEmail()"
                      class="send-code-again link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                      style="margin: 0 !important"
                      [ngStyle]="{
                        color: isSendCodeDisabled ? 'gray' : '#8231D3'
                      }"
                    >
                      <!-- Send code again -->
                      {{ "auth.sendCodeAgain" | translate }}
                    </button>
                  </div>
                  <div
                    *ngIf="isSendedCode"
                    class="admin__button-group button-group d-flex pt-1 justify-content-md-start justify-content-center"
                  >
                    <button
                      class="btn btn-primary btn-default w-100 btn-squared text-capitalize lh-normal px-50 signIn-createBtn"
                      [disabled]="!isFormValid() || !isValidEmail()"
                      (click)="login()"
                    >
                      <!-- Sign in -->
                      {{ "auth.signIn" | translate }}
                    </button>
                  </div>
                </div>
              </div>
              <!-- End: .card-body -->
            </div>
          </div>
          <!-- End: .edit-profile -->
        </div>
        <!-- End: .col-xl-5 -->
      </div>
    </div>
  </div>
  <!-- End: .admin-element  -->
</main>
<div
  class="lang-modal-overlay"
  [class.active]="isLangModalOpen"
  (click)="closeLangModal()"
>
  <div class="lang-modal" (click)="$event.stopPropagation()">
    <div class="lang-modal__header">
      <span class="lang-modal__title">{{ "choose_language" | translate }}</span>
      <button class="lang-modal__close" (click)="closeLangModal()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="lang-modal__list">
      <button
        *ngFor="let l of langOptions"
        class="lang-modal__item"
        [class.lang-modal__item--active]="lang.currentLang === l.code"
        (click)="selectLang(l.code)"
      >
        <span class="lang-modal__flag">{{ l.flag }}</span>
        <span class="lang-modal__name">{{ l.name }}</span>
        <span class="lang-modal__code">{{ l.code.toUpperCase() }}</span>
        <svg
          *ngIf="lang.currentLang === l.code"
          class="lang-modal__check"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </button>
    </div>
  </div>
</div>
